import React, { useEffect, useState, useRef } from 'react';
import { useIntl, FormattedMessage } from 'react-intl';
import { shallowEqual, useDispatch, useSelector } from 'react-redux';
import {
  Card,
  CardBody,
  CardFooter,
  CardHeader,
  CardHeaderIcon,
  CardHeaderToolbar,
  ModalProgressBar,
} from '../../../../../../_metronic/_partials/controls';
import { Modal, Tab } from 'react-bootstrap';
import Activities from '../../../../../components/Activities';
import * as actions from '../../../_redux/orders/ordersActions';
import {
  initialOrder,
  OrderStatusCssClasses,
  OrderStatusTitles,
} from '../OrdersUIHelpers';
import ChangedInfo from '../../../../../components/ChangedInfo';
import OrderMain from './Order/OrderMain';
import OrderItems from './Order/OrderItems';
import Shipping, { BOXES_URL } from './Shipping';

export function OrderViewDialog({
  history,
  match: {
    params: { id },
  },
}) {
  const intl = useIntl();
  const [tab, setTab] = useState('order');
  const [title, setTitle] = useState('');
  const [loading, setLoading] = useState(false);
  const dispatch = useDispatch();
  const [dialogError, setDialogError] = useState('');
  const titleText = intl.formatMessage({ id: 'ORDER.TITLE.DETAIL' });
  /*const refShipping = useRef();
  const [shippingResult, setShippingResult] = useState({
    boxes: [],
    items: [],
  });*/
  //console.log('id=', id);

  const { actionsLoading, orderForView, error, msg } = useSelector(
    (state) => ({
      actionsLoading: state.orders.actionsLoading,
      orderForView: state.orders.orderForView,
      error: state.orders.error,
      msg: state.orders.msg,
    }),
    shallowEqual
  );

  useEffect(() => {
    dispatch(actions.fetchOrder(id));
  }, [id, dispatch]);

  useEffect(() => {
    let _title = intl.formatMessage({ id: 'ORDER.QUICKACTIONS.TITLE' });
    if (orderForView && id) {
      _title = `${titleText}: #${orderForView.id}`;
    }

    setTitle(_title);
  }, [orderForView, id]);

  useEffect(() => {
    setDialogError(error);
  }, [error]);

  const onHide = () => {
    history.push(`/orders`);
  };

  const PrintStatus = () => {
    let status = 0;
    if (orderForView) status = orderForView.status;
    return (
      <span
        className={`label label-lg label-${
          OrderStatusCssClasses[status + 1]
        } label-inline text-center`}
      >
        {OrderStatusTitles[status + 1]}
      </span>
    );
  };

  const saveOrder = (values) => {
    if (!loading) {
      setLoading(true);
      //console.log('saveOrder', values);
      if (!orderForView) {
        dispatch(actions.createOrder(values));
      } else {
        dispatch(actions.updateOrder(values));
      }
      setLoading(false);
    }
  };

  const saveOrderItems = () => {
    dispatch(actions.fetchOrder(orderForView.orderCode));
  };
  const saveBox = () => {
    /*     refShipping.current.saveBox({
      orderCode: shippingResult.orderCode,
      boxes: shippingResult.boxes,
      items: shippingResult.items,
    }); */
    dispatch(actions.fetchOrder(orderForView.orderCode));
  };

  const newClick = () => {
    dispatch(actions.clearOrder());
    history.push('/orders/new');
  };
  const btnRefNew = useRef();
  const newOrderClick = () => {
    //console.log('saveOrderClick');
    if (btnRefNew && btnRefNew.current) {
      btnRefNew.current.click();
    }
  };
  const btnRefSave = useRef();
  const saveOrderClick = () => {
    //console.log('saveOrderClick');
    if (btnRefSave && btnRefSave.current) {
      btnRefSave.current.click();
    }
  };

  return (
    <>
      <Modal.Body className='overlay overlay-block cursor-default'>
        {actionsLoading && <ModalProgressBar />}
        {actionsLoading && (
          <div className='overlay-layer bg-transparent'>
            <div className='spinner spinner-lg spinner-success' />
          </div>
        )}
        <Card>
          <CardHeader title={`${title}`}>
            <CardHeaderToolbar>
              {PrintStatus()}
              <> </>
              <button
                type='button'
                onClick={onHide}
                className='btn btn-light btn-elevate'
              >
                <FormattedMessage id='GENERAL.BUTTON.CANCEL' />
              </button>
              <> </>
              <button
                type='button'
                className='btn btn-secondary ml-2'
                onClick={newOrderClick}
                disabled={orderForView && orderForView.orderCode ? false : true}
              >
                <FormattedMessage id='GENERAL.BUTTON.NEW' />
                {loading && (
                  <span
                    id='orderSaveLoading3'
                    className='ml-3 spinner spinner-white '
                  ></span>
                )}
              </button>
              <> </>
              {tab === 'order' && (
                <button
                  type='submit'
                  className='btn btn-primary ml-2'
                  onClick={saveOrderClick}
                >
                  <FormattedMessage id='GENERAL.BUTTON.SAVE' />
                  {loading && (
                    <span
                      id='orderSaveLoading2'
                      className='ml-3 spinner spinner-white '
                    ></span>
                  )}
                </button>
              )}
            </CardHeaderToolbar>
          </CardHeader>
          <CardBody>
            <ul className='nav nav-tabs nav-tabs-line ' role='tablist'>
              <li className='nav-item' onClick={() => setTab('order')}>
                <a
                  className={`nav-link ${tab === 'order' && 'active'}`}
                  data-toggle='tab'
                  role='tab'
                  aria-selected={(tab === 'order').toString()}
                >
                  Бүртгэл
                </a>
              </li>
              <li className='nav-item' onClick={() => setTab('activity')}>
                <a
                  className={`nav-link ${tab === 'activity' && 'active'}`}
                  data-toggle='tab'
                  role='button'
                  aria-selected={(tab === 'activity').toString()}
                >
                  Өөрчлөлтийн түүх
                </a>
              </li>
            </ul>
            <div className='mt-5'>
              {tab === 'order' && (
                <>
                  <div className='form-group row'>
                    <div className='col-12'>
                      <OrderMain
                        actionsLoading={actionsLoading}
                        orderForView={orderForView || initialOrder}
                        initialOrder={initialOrder}
                        btnRefSave={btnRefSave}
                        btnRefNew={btnRefNew}
                        saveOrder={saveOrder}
                        newClick={newClick}
                        onHide={onHide}
                        dialogError={dialogError}
                        msg={msg}
                      />
                    </div>
                  </div>
                  {orderForView && (
                    <div className='form-group row'>
                      <div className='col-6'>
                        <OrderItems
                          order={orderForView}
                          saveOrderItems={saveOrderItems}
                        />
                      </div>
                      <div className='col-6'>
                        <Shipping
                          order={orderForView}
                          saveBox={saveBox}
                          dialogError={dialogError}
                          //setShippingResult={setShippingResult}
                          //ref={refShipping}
                        />
                      </div>
                    </div>
                  )}
                </>
              )}
              {tab === 'activity' && id && (
                <Activities orderCode={orderForView.id} />
              )}
            </div>
          </CardBody>
        </Card>
      </Modal.Body>
      <Modal.Footer>
        {orderForView && (
          <ChangedInfo
            value={{
              createdByName: orderForView.createdByName,
              createdAt: orderForView.createdAt,
              updatedByName: orderForView.createdByName,
              updatedAt: orderForView.updatedAt,
            }}
          />
        )}
      </Modal.Footer>
    </>
  );
}
